import { cipo } from 'cipo';
    
cipo.controller('sqmController', 
function ($scope, $state) {
    
});
